export default __webpack_public_path__ + "static/christmas-trees-38a1dcbe6eeb1e96872a94c6782a9909.gif";